var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(-0.078 0.365)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(0.078 -0.365)",
    fill: "#e6496a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_68",
    "data-name": "Layer 68",
    transform: "translate(6.895 8.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M24.122,20.623V16.2a1.106,1.106,0,1,0-2.212,0v1.637L15,9.941A1.137,1.137,0,0,0,13.352,9.9l-2.477,2.5L3.908,4.412a1.106,1.106,0,1,0-1.659,1.46l7.74,8.846a1.106,1.106,0,0,0,1.614.055L14.17,12.3l6.27,7.221H18.593a1.106,1.106,0,1,0,0,2.212h4.423A1.106,1.106,0,0,0,24.122,20.623Z",
    transform: "translate(-1.941 -4)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossIco);
export default __webpack_public_path__ + "static/media/lossIco.1ef9a2aaedf3722dda8f8e09c69f1c0e.svg";
export { ForwardRef as ReactComponent };